<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BannerApi from "@/services/banner-api";
import Vue from 'vue'
// import Promotion from "@/components/promotion"; 

//import DynamicMarquee from 'vue-dynamic-marquee';

// import ItemCard from "@/components/itemCard";
// import CategoryCard from "@/components/CategoryCard";
import highlightsOmn from "@/components/highlightsNews-omn";
import highlightsSmallOmn from "@/components/highlights-omn";



import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import carousel from 'vue-owl-carousel'
//import simplebar from "simplebar-vue";

import ReportingApi from "@/services/reporting-api";
import UsersApi from "@/services/users-api";

export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout/*, simplebar, carousel, ItemCard, CategoryCard*/, highlightsOmn, highlightsSmallOmn/*, Promotion*/
  },
  
  computed: {

    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
      };

      return vueAppCustomerInfo;
    },

    windowWidth() {
      return window.innerWidth;
    },

    role() {
      return this.$cookies.get('userr');
    }

  },

  data() {
    return {
      bannerList: [],
      isBannerTableBusy: false,

      nowAvailableItems: [],
      newSuppliers: [],
      newItems: [],

      topItems:[],
      isGetTopItemsStarting: false,

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,

      homeLogos:["logo-bosch", "logo-cerva", "logo-ridgid", "logo-esab", "logo-facom", "logo-defender", "logo-tractel", "logo-3M", "logo-climax"],

      settings: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "edgeFriction": 0.35,
          "infinite": true,
          "speed": 1000,
          "autoplay": true,
          "slidesToShow": 1,
          "slidesToScroll": 1,

          "fade": true,
          "arrows": false,

          //"vertical": true,
          //"verticalSwiping": true
        },


        settingsNewSuppliersBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 5000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 5,
        },

        settingsNewItemBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 4000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 1,
          "arrows": true,


          "responsive": [
              {
                "breakpoint": 1024,
                "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 600,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 480,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              }
            ]


        }
    };
  },

  mounted() {

    this.findBanner(this.windowWidth);

    this.getTopTenItems();
    

    this.findNowAvailableItems();
    this.getNewItems();
    this.getNewSuppliers();

   
    
  },

  methods: {
    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    

    getNewSuppliers(){
      /*SuppliersApi.getAllNewSuppliers().then(
        response => {
          this.newSuppliers = response;
        }
      )*/
    },

    getNewItems(){
      /*ItemsApi.findNewItems().then(
        response => {
          this.settingsNewItemBanner.slidesToShow = response.length < 3 ? response.length : 3;
          this.newItems = response;
        }
      )*/
    },

    findNowAvailableItems(){
      /*ItemsApi.findNowAvailableItems().then(
        response => {
          
          this.nowAvailableItems = response;
        }
      )*/
    },


    getTopTenItems(){
            this.isGetTopItemsStarting=true
            ReportingApi.getTopTenItemsForHome().then(
                (result) => {
                    this.topItems=result.list;
                }
            ).finally(()=>{
                this.isGetTopItemsStarting=false
            })
      },

      addAccountRequest() {
        UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(
              (result) => {
                  if (result) {
                    Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
                    this.newAccountCompanyName = null;
                    this.newAccountCompanyPhone = null;
                  }
              }
            ).finally(()=>{
            })
      },

      // bestSellersNextSlide() {

      //   //this.$refs['bestSellersCaroussel'].trigger('owl.next');

      //   this.$refs['bestSellersCaroussel'].trigger('prev.owl.carousel');

      // },

      goTopPage() {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      }

    


  }
};
</script>


<style>

.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}






.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}



.newitems .simplebar-scrollbar::before {
  background-color: #5cb45b;
}

.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}


carousel-item .active .img-fluid {
  border-radius:500px !important;
}

@media all and (max-width: 1199px) {
    .mobile-padding {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

  /* .carousel-caption {
  position: absolute;
  top: 60%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
} */

 .banner-overlay {
  position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #00acc840;
    z-index: 1;
    pointer-events: none;
} 

@media (max-width: 991.98px) {
  .banner-overlay {
    background-color: #93c3d1de; /* new background for mobile */
  }
}

.carousel-caption {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  z-index: 2;
}
.banner-image {
  position: relative;
  z-index: 0;
}



.catalog-background {
  padding-top: 75px;
    padding-bottom: 70px;
    background-image:   url('~@/assets/images/back.jpg');   
    background-position: center;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}


.footer-default {
  background: none;
}

@media (min-width: 992px) {
  .footer-default {
    background: #f7f6f6;
  }
}


</style>

<template>
  <Layout>


   
     
   

        <!-- Main Banners -->
        <div class="row pt-xl-0" >
          <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
              style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide class="bg-light"  
                          style="width:1920px; height:565px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-secondary">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                  <template #img>
                    <div class="banner-overlay"></div>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%" style="min-height:420px">
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-left ml-lg-5 ml-0 mt-lg-5 mt-0">
                   
                    <h1 class=" font-weight-bold banner-title-white text-primary text-lg-left text-center " style="font-size:3rem !important; font-weight:900 !important;">OMNIPHARM</h1>
                    <h2 class="d-none d-md-block text-white mt-4 banner-title text-lg-left text-center" style="font-weight:900 !important; font-size:2.5rem !important;">Votre partenaire au quotidien</h2>

                  <h2 class="text-white font-weight-bold font-size-24 mt-3 mb-5 banner-title text-lg-left text-center" style="font-size:1.3rem !important;" >
                   Répartiteur en produits pharmaceutiques et Para-pharmaceutiques
                  </h2>



                  <!-- <div class="mt-4 text-left" >
                    <a class="pr-md-3" href="/catalogue">
                      <b-button variant="primary"  style="padding: 10px 26px; " class="font-weight-bold  font-size-18">
                        <div class="font-weight-normal mb-1 font-size-14">Disponibilités et prix instantanés</div>
                        <span class="font-weight-bold text-uppercase ">Consulter le catalogue</span>
                      </b-button>
                    </a>    

                    <a class="pl-3 d-none d-md-inline" href="/catalogue">
                      <b-button variant="primary"  style="padding: 10px 26px; " class="font-weight-bold  font-size-18">
                        <div class="font-weight-normal mb-1 font-size-14">Commandez en toute sécurité</div>
                        <span class="font-weight-bold text-uppercase">Passez votre commande</span>
                      </b-button>
                    </a>    
                
                  </div> -->




                 




                </div>
                
              
            </b-carousel>



        </div>
      </div>



        </div>

      


        <div class="row pt-xl-0 pb-0" >
          <div class="col-12">
            <!--div class="overlays"/-->
            <!-- <video width="100%"  class="banner-video-mobile" loop playsinline autoplay muted  >
              <source src="@/assets/videos/OMNIPHARM.mp4" type="video/mp4" >
            </video> -->
            
          </div>
				</div>
  
    
    <div class="">

    

        <!-- Promotions -->
        <!-- <highlights :propDisplayTitle="false" :propWhiteBackground="false" /> -->

        <!-- TOP ITEMS -->
        <!-- border: 1px solid #eaf8f8;  -->
        
 
        <div class="row mt-5 pt-xl-4 pb-lg-4 pb-0 mb-lg-4 mb-0 p-0 p-md-4 home-page-80-width "  style="border-radius:10px;">
          <div class="col-12"> 

              <div class="row ml-4 mr-4 mt-2 mb-2">
                <div class="col-xl-6 col-12 text-left p-4">
                  <h2 class="text-primary font-weight-bold">
                    
                          A propos de OmniPharm

                    
                  
                  </h2>
                 
                
                  <p class="text-justify font-size-16 text-dark mt-4">Omnipharm Répartition est un des leaders dans la logistique de santé, qui commence du laboratoire jusqu’au pharmacien. Notre métier est d’assurer la distribution des médicaments et des produits parapharmaceutiques. Nous nous appuyons sur un maillage territorial puissant qui garantit une meilleure efficacité d’approvisionnement des pharmacies et une plus grande proximité pour les patients.

                    <p class="text-justify font-size-16 text-dark mt-4">Omnipharm est fière d’avoir une équipe professionnelle innovante, dévouée pour travailler au mieux de sa capacité chaque jour pour répondre à vos besoins.</p>

                    <p class="text-justify font-size-16 text-dark mt-4">Notre objectif est de faire de vous notre priorité numéro un.</p>


                  
                    <div class="row d-none">

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon1.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Médicaments</span>
                            <p class="text-secondary  " style="font-weight:500; ">Médicaments princeps & génériques</p>
                          </div>
                        </div>

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon2.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Produits Para-Pharmaceutiques</span>
                            <p class="text-secondary  " style="font-weight:500; ">Beauté, bien-être et soins personnels</p>
                          </div>
                        </div>

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon3.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Dispositifs Médicaux</span>
                            <p class="text-secondary  " style="font-weight:500; ">Instruments, appareils, équipements, ...</p>
                          </div>
                        </div>

                        

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon4.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Compléments Alimentaires</span>
                            <p class="text-secondary  " style="font-weight:500; ">Vitamines, minéraux, oligo-éléments, ...</p>
                          </div>
                        </div>

                       

                    </div>

                    <div class="row mt-3 d-none ">

                          <div class="col-6 pr-3">

                            
                            <router-link to="/catalogue" >
                            
                              <b-button variant="outline-success" class="w-100">
                                <i class="  far fa-user font-size-18 mr-2 "></i> 
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-none d-md-inline">Espace Professionnels</span>
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-md-none">PRO</span>

                                  
                              </b-button>
                            </router-link>
                          </div>

                          <div class="col-6 pl-3 ">
                            <router-link to="/catalogue" >
                              <b-button variant="success" class="w-100">
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-none d-md-inline">DECOUVREZ NOS ARTICLES</span>
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-md-none">ARTICLES</span>
                                  <i class="ml-2 font-size-20 fa fa-angle-right d-none d-md-inline"></i>
                              </b-button>
                              </router-link>
                            </div>

                    </div>

                   
                </div>

                <div class="col-xl-6 col-0 text-left p-md-5 p-2">
                
                  <video width="100%" style="border-radius:5px;" class="banner-video-mobile" loop playsinline autoplay muted  >
                    <source src="@/assets/videos/omnipharm.mp4" type="video/mp4"  >
                  </video>


                </div>

              </div>


          </div>
          
        
        </div>



      

        
           <!-- Promotions -->
       <highlightsOmn :propDisplayTitle="true" />

         <div class="contact-section  m-lg-5 m-0">
        <div class="row no-gutters ">


              

          <!-- Contact Info -->
          <div class="col-12  col-md-12  text-primary p-4 d-flex align-items-center justify-content-center">
            <div class="w-100 mt-2 mt-lg-5 mt-md-0 mb-5 mb-md-0">
              <div class="row">
                <!-- Adresse -->
                <div class="col-12 col-sm-4 text-center mb-4 mb-lg-0">
                  <div class="d-flex justify-content-center mb-2">
                    <span class="icon-circle">
                      <i class="fas fa-map-marker-alt fa-lg"></i>
                    </span>
                  </div>
                  <!-- <h5 class="text-uppercase" style="letter-spacing: 1.2px;">Adresse</h5> -->
                  <p class="mb-0 font-size-16 mt-3 font-weight-bold">{{ vueAppCustomerInfo.address }}</p>
                </div>

                <div class="col-12 col-sm-4 text-center mb-4 mb-lg-0">
                  <div class="d-flex justify-content-center mb-2">
                    <span class="icon-circle">
                      <i class="fas fa-envelope fa-lg"></i>
                    </span>
                  </div>
                  <!-- <h5 class="text-uppercase">Email</h5> -->
                  <p class="mb-0 font-size-16 mt-3 font-weight-bold">
                    <a :href="'mailto:' + vueAppCustomerInfo.email" class="text-primary">
                      {{ vueAppCustomerInfo.email }}
                    </a>
                  </p>
                </div>

                <div class="col-12 col-sm-4 text-center mb-4 mb-lg-0">
                  <div class="d-flex justify-content-center mb-2">
                    <span class="icon-circle">
                      <i class="fas fa-phone fa-lg"></i>
                    </span>
                  </div>
                  <!-- <h5 class="text-uppercase">Téléphone</h5> -->
                  <p class="mb-0 font-size-16 mt-3 font-weight-bold">{{ vueAppCustomerInfo.phone }}</p>
                </div>

                <!-- <div class="col-12 col-sm-6 text-center mt-4">
                  <h5 class="text-uppercase mt-md-4 mt-sm-3">Contactez-nous</h5>
                  <div class="mt-2">
                    <p class="mb-0 font-size-16 mt-3 font-weight-bold">Du lundi au samedi de 8h à 17h.</p>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 p-3 p-lg-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.3449232599705!2d10.733273115768176!3d34.7720910804161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301d3e8fade70d9%3A0x462ab52c320678a9!2sOmnipharm%20Repartition!5e0!3m2!1sen!2stn!4v1665706260357!5m2!1sen!2stn"
              width="100%" height="100%" frameborder="0" style="border:0; min-height: 400px;" allowfullscreen=""
              loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

         
        <div class="row bg-white">

            <div class="col-12">
              <highlightsSmallOmn :propDisplayTitle="true" class="" />
            </div>
        </div>


    

        
       
        
       
        <div class="bg-light footer-default pt-5 mt-5"  >
<div class="row pb-5 mt-1 pt-1 home-page-80-width" style="padding-bottom:40px; ">
            <div class="col-12"> 

                <div class="row  pb-1">

                    <div class="col-xl-2 col-md-6 col-sm-12 col-xs-12 p-2 text-left" >

                            <img src="@/assets/images/omn/logo.png" alt height="50" />
              
                        <p class=" d-none mt-3 p-3 text-secondary text-justify font-weight-bold" style="color:#92B9B1">Grossiste et Répartiteur de médicaments, de dispositifs médicaux, de produits pharmaceutiques et para-pharmaceutiques depuis 1987.</p>
                    </div>


                    <div class=" col-xl-4 col-md-6 col-sm-12 col-xs-12 p-2 text-left" >
                      <h5 class="text-primary font-weight-bold " >CONTACTEZ-NOUS</h5>


                        <ul style="list-style: none;margin: 0;padding: 0; " class="mt-4">
                            <li class="text-dark font-weight-normal font-size-14 mt-2">
                              <!-- <i class=" fas fa-map-marker-alt mr-2" style="color:#92B9B1;"/> -->
                              <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.address}}</span>
                            </li>

                            <li class="font-weight-normal font-size-14 mt-2">
                              <!-- <i class="fas fa-envelope mr-2" style="color:#92B9B1;"/> -->
                              <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.email}}</span>
                            </li>          

                            <li class=" font-weight-normal font-size-14 mt-2">
                              <!-- <i class=" fas fa-phone-alt mr-2" style="color:#92B9B1;" /> -->
                              <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.phone}}</span>
                            </li>    
                        </ul>
                    </div>


                    

                    <div class=" col-xl-3 col-md-6 col-sm-12 col-xs-12 p-2 text-left">
                      <h5 class="text-primary font-weight-bold " style="">NOS PRODUITS</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                        
                        <li class="font-size-14 mt-2 ">
                              <!-- <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/> -->
                              <a class="text-dark" href="/catalogue">Tout le catalogue</a>
                            </li>

                        <li class="font-size-14 mt-2">
                              <!-- <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/> -->
                              <a class="text-dark" href="/catalogue">Produits Pharmaceutiques</a>
                            </li>

                            <li class="font-size-14 mt-2">
                              <!-- <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/> -->
                              <a class="text-dark" href="/catalogue">Produits Para-Pharmaceutiques</a>
                            </li>

                            <li class="font-size-14 mt-2">
                              <!-- <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/> -->
                              <a class="text-dark" href="/catalogue">Dispositifs Médicaux</a>
                            </li>

                        </ul>

                    </div>

                    <!-- <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12 p-4 text-left">
                      <h5 class="text-white font-weight-bold" style="">FAMILLES DE PRODUITS</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                        
                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="/catalogue/divers">Divers</a>
                            </li>

                          <li class="font-size-12 mt-2">
                              <a class="text-white" href="/catalogue/soudage">Soudage</a>
                            </li>
                        
                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="/catalogue/manutention">Manutention</a>
                            </li>

                            
                        </ul>

                    </div> -->

                    <div class=" col-xl-2 col-md-6 col-sm-12 col-xs-12 p-2 text-left" >
                      
                        <h5 class="text-primary font-weight-bold" style="">ESPACE CLIENT</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                          
                            <li class="font-size-14 mt-2">
                              <!-- <i class=" fas fa-user mr-2" style="color:#92B9B1;"/> -->
                              <a class="text-dark" href="/profil">Profil Utilisateur</a>
                            </li>
                            
                            <li class="font-size-14 mt-2">

                              <!-- <i class=" fas fa-file-alt mr-2" style="color:#92B9B1;"/> -->
                              <a class="text-dark" href="/commandes">Commandes</a>
                            </li>
                        </ul>
                    </div>

                    <!-- <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12 p-4 text-left">
                      <h5 class="text-white font-weight-bold" style="">INFORMATIONS LÉGALES</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="">Conditions d'utilisation</a>
                            </li>

                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="">Mentions légales</a>
                            </li>

                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="">Protection des données</a>
                            </li>
                        </ul>
                    </div> -->

                    <div class="text-primary col-xl-1 col-md-12 col-sm-12 col-xs-12 p-2 text-right">
                      <a href="javascript:void(0);" @click="goTopPage()" class="text-primary font-weight-bold" style="font-size:36px;"><i class="far fa-arrow-alt-circle-up"/></a>
                    
                    </div>
                    

                  

                </div>

              

            </div>
            

          </div>
        </div>


        

    
         
       
    
    </div>
    

    


 


  </Layout>
</template>


<style scoped>
.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #fff; font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); 
  font-weight: 700;
}

.contact-section {
  background-color: #fff;/*#22bbed;*/
}

.contact-section .fa {
  color: #ffffff;
}

.contact-section h5 {
  color: #ffffff;
}


.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid #223c8a;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent; /* or use a color like #333 if needed */
  color: #223c8a ;
  font-size: 18px;
}



</style>

